import { HOST } from "../constants/HostConstants";
export const transactionDelete = async (
  transaction_id,
  user_id,
  email_address,
  amount,
  { setTransactions }
) => {
  try {
    const res = await fetch(`${HOST}/api/transaction/transactionDelete`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ transaction_id, user_id, email_address, amount }),
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    const text = await res.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch {
      return { success: false, error: text };
    }
    if (!res.ok) return { success: false, error: data?.error || "Failed" };
    setTransactions(Array.isArray(data) ? data : []);
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.message };
  }
};
